import { render, staticRenderFns } from "./hs_code.vue?vue&type=template&id=ddfd774a&scoped=true&"
import script from "./hs_code.vue?vue&type=script&lang=js&"
export * from "./hs_code.vue?vue&type=script&lang=js&"
import style0 from "./hs_code.vue?vue&type=style&index=0&id=ddfd774a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfd774a",
  null
  
)

export default component.exports